export const getStatusIcon = (status) => {
  switch (status) {
    case 'deleting':
      return (
        <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      );
    case 'success':
      return (
        <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center">
          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
      );
    case 'error':
      return (
        <div className="w-4 h-4 bg-red-500 rounded-full flex items-center justify-center">
          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </div>
      );
    default: // 'pending'
      return (
        <div className="w-4 h-4 border-2 border-gray-300 rounded-full"></div>
      );
  }
};

export const getStatusText = (status) => {
  switch (status) {
    case 'deleting': return 'Deleting...';
    case 'success': return 'Success';
    case 'error': return 'Failed';
    default: return 'Pending';
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'deleting': return 'text-blue-600';
    case 'success': return 'text-green-600';
    case 'error': return 'text-red-600';
    default: return 'text-gray-500';
  }
};

// Optional: Combined function if you always use all three together
export const getStatusInfo = (status) => {
  return {
    icon: getStatusIcon(status),
    text: getStatusText(status),
    color: getStatusColor(status)
  };
};